module.exports = __webpack_public_path__ + "img/xrp.642461bc.svg";